import styled from 'styled-components'

const StyledImg = styled.img`
  height: 310px;
`

const StyledComponent = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
`

export { StyledImg, StyledComponent }
